/**
 * Mapeo explícito entre los IDs de contexto de la aplicación y las hojas del Excel
 * Hojas basadas en: problemas_21.xlsx
 */

const EXCEL_SHEET_MAPPING = {
    // 🎈 Momentos especiales
    'cumpleanos': 'CUMPLEAÑOS',
    'feria': 'FERIA',
    'circo': 'CIRCO',

    // 🌳 Entornos naturales
    'granja': 'GRANJA',
    'acuario': 'ACUARIO',
    'excursion_monte': 'BOSQUE',

    // 🏠 Acciones cotidianas
    'juguetes': 'JUGUETES',
    'ordenando_cuarto': 'ORDENAR',
    'manualidades': 'MANUALIDADES',

    // 🛒 Lugares de compras (Categorizado como cotidianas en Excel pero mantiene IDs originales)
    'centro_comercial': 'CENTRO COMERCIAL',
    'fruteria': 'FRUTERÍA', // Ojo con la tilde, debe coincidir con el nombre de la hoja

    // 📚 Lugares de interés
    'patio_colegio': 'PATIO',
    'museo': 'MUSEO',
    'biblioteca': 'BIBLIOTECA'
};

// Exportar para Node.js y navegadores
if (typeof module !== 'undefined' && module.exports) {
    module.exports = EXCEL_SHEET_MAPPING;
} else {
    window.EXCEL_SHEET_MAPPING = EXCEL_SHEET_MAPPING;
}
